import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyDhyD4CdHd2CeWO7zqhYi00pW0J8Ov707U",
    authDomain: "hacksc2020-a069e.firebaseapp.com",
    databaseURL: "https://hacksc2020-a069e.firebaseio.com",
    projectId: "hacksc2020-a069e",
    storageBucket: "hacksc2020-a069e.appspot.com",
    messagingSenderId: "374861270812",
    appId: "1:374861270812:web:1eea5ac2e8977b3f5334d9",
    measurementId: "G-L42E739WWG"
};

firebase.initializeApp(config);

export default firebase;